import { t } from '@lingui/core/macro';
import NavItem from './NavItem';
import type { User, ViewMode } from '../../types/api';

interface SidebarPrimaryNavProps {
  mode: ViewMode;
  counts?: User['counts'];
}

function SidebarPrimaryNav({ mode, counts }: SidebarPrimaryNavProps) {
  return (
    <>
      <NavItem
        to="/"
        icon="home"
        label={t`Home`}
        count={counts?.unread}
        mode={mode}
        matchMode="unread"
        isDropTarget={counts !== undefined && mode !== 'unread'}
        dropTargetType="home"
      />
      <NavItem
        to="/liked"
        icon="like"
        label={t`Liked`}
        count={counts?.liked}
        mode={mode}
        matchMode="liked"
        isDropTarget={counts !== undefined && mode !== 'liked'}
        dropTargetType="liked"
      />
      <NavItem
        to="/archive"
        icon="archive"
        label={t`Archive`}
        count={counts?.archived}
        mode={mode}
        matchMode="archive"
        isDropTarget={counts !== undefined && mode !== 'archive'}
        dropTargetType="archive"
      />
      <NavItem
        to="/notes"
        icon="note"
        label={t`Notes`}
        count={counts?.notes}
        mode={mode}
        matchMode="highlights"
      />
    </>
  );
}

export default SidebarPrimaryNav;
